export default __webpack_public_path__ + "static/media/coupon.9491799b.png";